module.exports = __webpack_public_path__ + "static/hostgator-7f51ee3e3515a8dfc4eb281134968516.svg";